import React from 'react';
import classNames from 'classnames';
import { TableRow, withStyles } from '@material-ui/core';
import { TableCellWithConfig } from 'components';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import styles from './styles';
import PropTypes from 'prop-types';
import Columns from '../../columns';

function StopRow(props) {
  const { stop, columnConfigs, isSelected, onClick, classes, shouldHover, t } =
    props;
  return (
    <TableRow
      className={classNames(classes.tableRow, 'cursorPointer')}
      hover={shouldHover}
      key={stop.id}
      onClick={onClick}
      selected={isSelected}
    >
      {columnConfigs.map((columnConfig) => (
        <TableCellWithConfig
          config={columnConfig}
          key={columnConfig.order}
          width={columnConfig.width}
        >
          {Columns[columnConfig.columnName].body({ templateStop: stop, t })}
        </TableCellWithConfig>
      ))}
    </TableRow>
  );
}

StopRow.propTypes = {
  stop: PropTypes.object.isRequired,
  columnConfigs: PropTypes.array.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  shouldHover: PropTypes.bool,
};

export default compose(withStyles(styles), withTranslation())(StopRow);
